// WhatsApp helper — normalize any BD-format number to international wa.me digits
// Rules:
//   "01888496974"     → "8801888496974"
//   "+8801888496974"  → "8801888496974"
//   "8801888496974"   → "8801888496974"
//   "880-1888-496974" → "8801888496974"
//   ""                → "8801888496974"  (fallback to platform WhatsApp)
export const DEFAULT_WA = "8801888496974";

export function waDigits(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return DEFAULT_WA;
  if (digits.startsWith("880")) return digits;
  // Local BD number starting with 0 (e.g. 01xxxxxxxxx) → drop the leading 0, prefix 880
  if (digits.startsWith("0")) return "880" + digits.slice(1);
  // Bare number without leading 0 (e.g. 1xxxxxxxxx) — assume BD
  if (digits.length === 10 && digits.startsWith("1")) return "880" + digits;
  return digits;
}

export function waLink(number, text) {
  const d = waDigits(number);
  const t = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${d}${t}`;
}
